import React from 'react';
import {Platform} from 'react-native';
import Svg, {Circle, Ellipse, Path, Polygon, Polyline, Rect} from 'react-native-svg';
import { shadedFill } from '@/constants/utils/diagramScene.cjs';

// Construct only fixed primitives from validated numeric geometry. Never parse
// model-authored SVG/XML, path strings, styles, URLs or event handlers.
export default function DiagramDrawing({shapes, tones, fills, onPartPress}) {
  return <Svg width="100%" height="100%" viewBox="0 0 1000 600" style={{position:'absolute',left:0,top:0}}>
    {shapes.map((shape,index)=>{
      const tone=shape.tone||'ink';
      const props={stroke:shape.smooth?shadedFill(fills[tone],shape.shade):tones[tone],strokeWidth:shape.strokeWidth||3,
        fill:shape.filled?(shape.shade===undefined?fills[tone]:shadedFill(fills[tone],shape.shade)):'none',strokeLinecap:'round',strokeLinejoin:'round',
        ...(shape.opacity !== undefined && {opacity:shape.opacity}),
        ...(Platform.OS==='web' && shape.partId && {'data-diagram-part':shape.partId}),
        // SVG's web adapter otherwise replaces onClick with onPress and adds
        // native responder props to DOM elements. Null opts out of that mixin.
        ...(onPartPress && shape.partId && (Platform.OS==='web'
          ? {onClick:()=>onPartPress(shape.partId),onPress:null}
          : {onPress:()=>onPartPress(shape.partId)}))};
      if(shape.type==='line') return <Polyline key={index} {...props} points={shape.points.map(point=>point.join(',')).join(' ')} />;
      if(shape.type==='polygon') return <Polygon key={shape.key||index} {...props} points={shape.points.map(point=>point.join(',')).join(' ')} />;
      if(shape.type==='curve') {
        const [start,c1,c2,end]=shape.points;
        return <Path key={index} {...props} d={`M ${start.join(' ')} C ${c1.join(' ')} ${c2.join(' ')} ${end.join(' ')}`} />;
      }
      if(shape.type==='circle') return <Circle key={index} {...props} cx={shape.cx} cy={shape.cy} r={shape.r} />;
      if(shape.type==='ellipse') return <Ellipse key={index} {...props} cx={shape.cx} cy={shape.cy} rx={shape.rx} ry={shape.ry} />;
      return <Rect key={index} {...props} x={shape.x} y={shape.y} width={shape.width} height={shape.height} rx={3} />;
    })}
  </Svg>;
}
